import { render, staticRenderFns } from "./LocaleComponent.vue?vue&type=template&id=7d6145d6&"
import script from "./LocaleComponent.vue?vue&type=script&lang=js&"
export * from "./LocaleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports